/* istanbul ignore file */
export const sortOptions = [
  {
    label: 'Sort: Relevance',
    value: 'relevance',
  },
  {
    label: 'Price high to low',
    value: 'priceHigh',
  },
  {
    label: 'Price low to high',
    value: 'priceLow',
  },
  {
    label: 'Newness',
    value: 'new',
  },
  {
    label: 'Popularity',
    value: 'popularity',
  },
  {
    label: 'Discount % high to low',
    value: 'discount',
  },
];
